import { ref, onMounted } from 'vue';
import { defineStore } from 'pinia';
import { useStorage } from 'vue3-storage';

const storage = useStorage();

export const useFavoritesStore = defineStore('favorites', () => {
    const favorites = ref([]);

    onMounted(() => {
        const storedFavorites = storage.getStorage({key:'favorites'})
            .then((result)=>{
                favorites.value = result.data;    
            })
            .catch(()=>{
                favorites.value = [];
            })
    });

    function toogleFavorite(id){
        const index = favorites.value.indexOf(id);
        if(index === -1){
            favorites.value.push(id);
        }else{
            favorites.value.splice(index, 1);
        }
        storage.setStorage({key:'favorites',data:favorites.value});
    }

    function isFavorite(id){
        return favorites.value.indexOf(id) !== -1;
    }
    return {
        favorites, toogleFavorite, isFavorite
    };
});